"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLongestExpireDate = exports.showAccountNo = exports.getIsPromptPay = exports.getOSAndVersion = exports.bufferToHex = exports.formatAsPem = void 0;
exports.consoleLog = consoleLog;
exports.isObjectEmpty = isObjectEmpty;
exports.isArrayEmpty = isArrayEmpty;
exports.roundNumberUp = roundNumberUp;
exports.roundNumberDown = roundNumberDown;
exports.numberFormat = numberFormat;
exports.numberFormatIntOrFloat = numberFormatIntOrFloat;
exports.isNumber = isNumber;
exports.isInt = isInt;
exports.isFloat = isFloat;
exports.uniqReduce = uniqReduce;
exports.numberWithCommas = numberWithCommas;
exports.formatBankNoX = formatBankNoX;
exports.formatBankNo = formatBankNo;
exports.formatPromptPay = formatPromptPay;
exports.formatAccountName = formatAccountName;
exports.str2ab = str2ab;
exports.ab2str = ab2str;
exports.arrayBufferToString = arrayBufferToString;
exports.arrayBufferToHex = arrayBufferToHex;
exports.getMobileOperatingSystem = getMobileOperatingSystem;
exports.generateUUID = generateUUID;
exports.checkIdCard = checkIdCard;
var isNil_1 = __importDefault(require("lodash/isNil"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var uuid_1 = require("uuid");
var constant_1 = require("../definition/constant");
function consoleLog() {
    var logs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        logs[_i] = arguments[_i];
    }
    // tslint:disable-next-line
    console.log.apply(console, logs);
}
// export function renderStringAsHtml(obj: any) {
//   return RenderHTML(obj);
// }
// export function renderStringAsHTMLParser(strHtml: string, transform?: any) {
//   const options = {} as any;
//   if (transform) {
//     options.transform = transform;
//   }
//   return ReactHtmlParser(strHtml, options);
// }
function isObjectEmpty(obj) {
    return (0, isNil_1.default)(obj) || (0, isEmpty_1.default)(obj);
}
function isArrayEmpty(obj) {
    return !(obj && Array.isArray(obj) && obj.length);
}
function roundNumberUp(num) {
    return Math.ceil(num);
}
function roundNumberDown(num) {
    return Math.floor(num);
}
function numberFormat(num, fractionDigits, round) {
    if (round === "up") {
        num = roundNumberUp(parseFloat(num).toFixed(2));
    }
    else if (round === "down") {
        num = roundNumberDown(parseFloat(num).toFixed(2));
    }
    var result;
    if (fractionDigits) {
        result = num === null || num === void 0 ? void 0 : num.toLocaleString(undefined, {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        });
    }
    else {
        result = num === null || num === void 0 ? void 0 : num.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }
    if (result === "-0") {
        result = "0";
    }
    return result;
}
function numberFormatIntOrFloat(n, round) {
    var roundOption = "up";
    if (round) {
        roundOption = round;
    }
    if (isInt(n)) {
        return numberFormat(n || 0, 0, roundOption);
    }
    else {
        return numberFormat(n || 0, 2);
    }
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}
function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
}
function uniqReduce(arr) {
    var s = new Set(arr);
    var it = s.values();
    return Array.from(it);
}
function numberWithCommas(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
function formatBankNoX(bankNoStr) {
    var no = bankNoStr.replace(/\D/g, "");
    var match = undefined;
    switch (no === null || no === void 0 ? void 0 : no.length) {
        case 10:
            match = no === null || no === void 0 ? void 0 : no.match(/^(\d{1,3})(\d{0,1})(\d{0,1})(\d{0,4})(\d{0,1})$/);
            if (match) {
                no = "xxx-x-x".concat(match[4], "-x");
            }
            break;
        case 12:
            match = no === null || no === void 0 ? void 0 : no.match(/^(\d{1,3})(\d{0,1})(\d{0,1})(\d{0,4})(\d{0,3})$/);
            if (match) {
                no = "xxx-x-x".concat(match[4], "-xxx");
            }
            break;
        case 13:
            match = no === null || no === void 0 ? void 0 : no.match(/^(\d{1,1})(\d{0,4})(\d{0,4})(\d{0,1})(\d{0,2})(\d{0,1})$/);
            if (match) {
                no = "x-xxxx-xxxx".concat(match[4], "-").concat(match[5], "-").concat(match[6]);
            }
            break;
    }
    return no;
}
function formatBankNo(val) {
    if (val) {
        var first = val.substring(0, 3) || "";
        var second = val.substring(3, 4) || "";
        var thrid = val.substring(4, 9) || "";
        var fourth = val.substring(9, val.length) || "";
        return (first +
            (second !== "" ? "-" + second : "") +
            (thrid !== "" ? "-" + thrid : "") +
            (fourth !== "" ? "-" + fourth : ""));
    }
    return "Not found";
}
function formatPromptPay(val) {
    if (val.length === 13) {
        // x-xxxx-xxxxx-xx-x
        var arr = [
            val.substring(0, 1),
            val.substring(1, 5),
            val.substring(5, 10),
            val.substring(10, 12),
            val.substring(12, 13)
        ];
        return arr.join("-");
    }
    else if (val.length === 10) {
        // xxx-xxx-xxxx
        var arr = [
            val.substring(0, 3),
            val.substring(3, 6),
            val.substring(6, 10)
        ];
        return arr.join("-");
    }
    return val;
}
function formatAccountName(accName) {
    var names = accName.split(" ").filter(function (item) { return item.trim() !== ""; });
    if (!isArrayEmpty(names) && names.length > 1) {
        var lastname = names.pop();
        lastname = lastname.length > 1 ? lastname.slice(0, 1) : lastname;
        names.push(lastname);
        accName = names.join(" ");
    }
    return accName;
}
// export function formatThaiDateTime(
//   datetime: Date,
//   lang: string,
//   noSec?: boolean,
//   noYear?: boolean
// ) {
//   const defaultDate = "2019-01-11T10:20:30Z";
//   // Date format without second
//   const year = moment(datetime || defaultDate).format("YYYY");
//   const month = moment(datetime || defaultDate).format("MM");
//   const date = moment(datetime || defaultDate).format(
//     lang === Language.EN ? "Do" : "DD"
//   );
//   // Format 24H
//   let time = strTime(datetime || defaultDate);
//   if (noSec) {
//     time = strTime(datetime || defaultDate, noSec);
//     if (noYear) {
//       return date + " " + shortMonth(+month) + ", " + time;
//     }
//     return (
//       date + " " + shortMonth(+month) + " " + shortYear(+year) + ", " + time
//     );
//   } else {
//     return (
//       date + " " + shortMonth(+month) + " " + shortYear(+year) + ", " + time
//     );
//   }
// }
// export function formatShortThaiDate(
//   datetime: string | Date,
//   lang: string,
//   noYear?: boolean
// ) {
//   const defaultDate = "2019-01-11T10:20:30Z";
//   const year = moment(datetime || defaultDate).format("YYYY");
//   const month = moment(datetime || defaultDate).format("MM");
//   const date = moment(datetime || defaultDate).format(
//     lang === Language.EN ? "Do" : "DD"
//   );
//   if (noYear) {
//     return date + " " + shortMonth(+month);
//   }
//   return date + " " + shortMonth(+month) + " " + shortYear(+year);
// }
var formatAsPem = function (str) {
    var finalString = "-----BEGIN PUBLIC KEY-----\n";
    while (str.length > 0) {
        finalString += str.substring(0, 64) + "\n";
        str = str.substring(64);
    }
    finalString = finalString + "-----END PUBLIC KEY-----";
    return finalString;
};
exports.formatAsPem = formatAsPem;
function str2ab(message) {
    var buffer = new ArrayBuffer(message.length);
    var bufferView = new Uint8Array(buffer);
    var len = message.length;
    for (var i = 0, strLen = len; i < strLen; i++) {
        bufferView[i] = message.charCodeAt(i);
    }
    return buffer;
}
function ab2str(buf) {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
}
function arrayBufferToString(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return binary;
}
function arrayBufferToHex(buffer) {
    var s = "";
    var h = "0123456789abcdef";
    new Uint8Array(buffer).forEach(function (v) {
        // tslint:disable-next-line
        s += h[v >> 4] + h[v & 15];
    });
    return s;
}
var bufferToHex = function (buffer) {
    var s = "";
    var h = "0123456789abcdef";
    new Uint8Array(buffer).forEach(function (v) {
        // tslint:disable-next-line
        s += h[v >> 4] + h[v & 15];
    });
    return s;
};
exports.bufferToHex = bufferToHex;
// export const hexTobuffer = (hex) => {
//     return new Uint8Array(
//         hex.match(/[\da-f]{2}/gi).map((h) => {
//             return parseInt(h, 16);
//         })
//     );
// };
/**
 * Partially from
 * JavaScript Client Detection
 * (C) viazenetti GmbH (Christian Ludwig)
 */
var getOSAndVersion = function () {
    var os;
    var osVersion;
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    // system
    var clientStrings = [
        { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
        { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
        { s: "Windows Vista", r: /Windows NT 6.0/ },
        { s: "Windows Server 2003", r: /Windows NT 5.2/ },
        { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
        { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
        { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
        { s: "Windows 98", r: /(Windows 98|Win98)/ },
        { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        { s: "Windows CE", r: /Windows CE/ },
        { s: "Windows 3.11", r: /Win16/ },
        { s: "Android", r: /Android/ },
        { s: "Open BSD", r: /OpenBSD/ },
        { s: "Sun OS", r: /SunOS/ },
        { s: "Chrome OS", r: /CrOS/ },
        { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
        { s: "iOS", r: /(iPhone|iPad|iPod)/ },
        { s: "Mac OS X", r: /Mac OS X/ },
        { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: "QNX", r: /QNX/ },
        { s: "UNIX", r: /UNIX/ },
        { s: "BeOS", r: /BeOS/ },
        { s: "OS/2", r: /OS\/2/ },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    var filteredCs = clientStrings.find(function (cs) { return cs.r.test(nAgt); });
    var filteredOS = filteredCs ? filteredCs.s : "";
    if (filteredOS) {
        os = filteredOS;
    }
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch (os) {
        case "Mac OS":
        case "Mac OS X":
        case "Android":
            osVersion =
                /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(nAgt)[1];
            break;
        case "iOS":
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion =
                osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] || 0);
            break;
        default:
            console.log("OS NOT detected");
    }
    return { os: os, version: osVersion };
};
exports.getOSAndVersion = getOSAndVersion;
function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return constant_1.MobileOS.Windows;
    }
    if (/android/i.test(userAgent)) {
        return constant_1.MobileOS.Android;
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return constant_1.MobileOS.IOS;
    }
    return "unknown";
}
function generateUUID() {
    return (0, uuid_1.v4)();
}
function checkIdCard(id) {
    if (id.length !== 13) {
        return false;
    }
    var sum = 0;
    for (var i = 0; i < 12; i++) {
        sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 !== parseFloat(id.charAt(12))) {
        return false;
    }
    return true;
}
// export function objectId() {
//     return (
//         hex(Date.now() / 1000) +
//         " ".repeat(16).replace(/./g, () => hex(Math.random() * 16))
//     );
// }
var getIsPromptPay = function (recvProxyType) {
    return [
        "NATID" /* National ID */,
        "MSISDN" /* Mobile Number */,
        "EWALLETID" /* E-Wallet */,
        "EMAIL" /* E-Mail */,
        "BILLERID" /* Biller ID */
    ].some(function (item) { return item === recvProxyType; });
};
exports.getIsPromptPay = getIsPromptPay;
var showAccountNo = function (bankNo, isPrompPay) {
    return isPrompPay ? formatPromptPay(bankNo) : formatBankNo(bankNo);
};
exports.showAccountNo = showAccountNo;
var getLongestExpireDate = function () {
    // max expire date on chrome is 400 days
    // but on LINE Liff don't know
    return "Fri, 31 Dec 9999 23:59:59 GMT";
};
exports.getLongestExpireDate = getLongestExpireDate;
